import { useEffect, useState } from "react";
import { API_URL } from "..";
import MasterLayout from "../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import ExpenseViewLayer from "../components/ExpenseViewLayer";
import { useParams } from "react-router-dom";

const ViewExpensePage = () => {
  const [data, setData] = useState(null);
  const { id } = useParams();

  const fetchExpense = async () => {
    const headerList = {
      Accept: "*/*",
      "Content-type": "application/json",
    };

    const response = await fetch(`${API_URL}/api/expenses/${id}`, {
      method: "GET",
      headers: headerList,
    });

    const result = await response.json();

    if (response.status === 200) {
      setData(result.expense); // directly set object
    }
  };

  useEffect(() => {
    fetchExpense();
  }, []);

  return (
    <MasterLayout>
      <Breadcrumb title="View Expense" />
      {data && <ExpenseViewLayer data={data} />}
    </MasterLayout>
  );
};

export default ViewExpensePage;
